import { ChangeDefaultPassword } from '@you-go-vn/components';
import { message } from 'antd';
import { authService } from '../auth/services';
import { useAppDispatch } from '../../store';
import { useNavigate } from 'react-router-dom';
import { setAuthenInfo } from '../../store/authenInfoSlice';
const ChangeDefaultPasswordPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const token = localStorage.getItem('token');

  const value = localStorage.getItem('user');
  const user = typeof value === 'string' ? JSON.parse(value) : undefined;
  return (
    <ChangeDefaultPassword
      fullname={user?.fullname}
      onFinish={async (values) => {
        const hideMessage = message.loading('Đang gửi yêu cầu đổi mật khẩu', 0);
        try {
          const res = await authService.updatePassword(
            values,
            token as string,
          );
          if (res.data.message === 'success') {
            message.success('Thành công');
            return { success: true };
          }
          if (res.data.errors) {
            message.error('Đã xảy ra lỗi, vui lòng kiểm tra lại!');
            return { errors: res.data.errors };
          }
          throw new Error();
        } catch (error: any) {
          message.error('Đã xảy ra lỗi, vui lòng kiểm tra lại!');
          // if has field error

          if (error.response) {
            return { errors: error.response.data.errors };
          }
          return {};
        } finally {
          hideMessage();
        }
      }}
      onLogin={() => {
        dispatch(setAuthenInfo({ isPreLogin: true }));
        navigate('/login');
      }}
    />
  );
};

export default ChangeDefaultPasswordPage;
